import { render, staticRenderFns } from "./DebitWalletModal.vue?vue&type=template&id=5256f38e&"
import script from "./DebitWalletModal.vue?vue&type=script&lang=js&"
export * from "./DebitWalletModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports